import React from 'react';

import t from '@zimpel/common/helpers/i18n';
import useLanguageParam from '../useLanguageParam';
import OptOutPage from './OptOutPage';

const OptOutTestmail: React.FC = () => {
  const language = useLanguageParam();

  return <OptOutPage headline={t(`view.opt_out.header_${language}`)} message={t(`view.opt_out.testmail_${language}`)} />;
};

export default OptOutTestmail;
